<header id="page-topbar">
  <div class="navbar-header">
    <div class="d-flex">
      <!-- LOGO -->
      <!-- <div class="navbar-brand-box">
        <a href="/" class="logo logo-dark">
          <span class="logo-sm">
            <img src="assets/images/logo-light-new.svg" alt="" height="30">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo_light_new.png" alt="" height="45">
          </span>
        </a>

          <a href="/" class="logo logo-light">
          <span class="logo-sm">
            <img src="assets/images/logo-light-new.svg" alt="" height="22">
          </span>
          <span class="logo-lg">
            <img src="assets/images/logo_light_new.png" alt="" height="40">
          </span>
        </a>
      </div> -->

      <button type="button" class="btn btn-sm px-3 font-size-16 header-item" id="vertical-menu-btn"
        (click)="toggleMobileMenu($event)">
        <i class="fa fa-fw fa-bars"></i>
      </button>




    </div>

    <div class="d-flex">



      <div class="dropdown d-none d-lg-inline-block ml-1">
        <button type="button" class="btn header-item noti-icon" data-toggle="fullscreen" (click)="fullscreen()">
          <i class="bx bx-fullscreen"></i>
        </button>
      </div>


      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" id="page-header-user-dropdown" ngbDropdownToggle>
          <img class="" src="{{flag}}" alt="Header Language" height="16">
        </button>

        <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>

          <!-- item-->
          <a (click)="switch_lang('en')" class="dropdown-item notify-item">
            <img src="assets/images/flags/us.jpg" alt="user-image" class="mr-1" height="12"> <span
              class="align-middle">English</span>
          </a>
          <!-- item-->
          <a (click)="switch_lang('it')" class="dropdown-item notify-item">
            <img src="assets/images/flags/italy.jpg" alt="user-image" class="mr-1" height="12"> <span
              class="align-middle">Italian</span>
          </a>

        </div>
      </div>

      <div class="dropdown d-inline-block" ngbDropdown>
        <button type="button" class="btn header-item" ngbDropdownToggle id="page-header-user-dropdown">
          <img class="rounded-circle header-profile-user" src="assets/images/users/avatar-1.jpg" alt="Header Avatar">
          <span class="d-none d-xl-inline-block ml-1">{{'topbar.p' | translate}}</span>
          <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
          <!-- item-->
          <a *hasPermission="'BoxView'" class="dropdown-item" (click)="infoModal(infoDataModal)"><i
              class="bx bx-user font-size-16 align-middle mr-1"></i>
            {{'topbar.p' | translate}}</a>
          <!-- <a class="dropdown-item d-block" href="javascript: void(0);"><span
              class="badge badge-success float-right">11</span><i
              class="bx bx-wrench font-size-16 align-middle mr-1"></i> Settings</a> -->
          <div class="dropdown-divider"></div>
          <a class="dropdown-item text-danger" href="javascript: void(0);" (click)="logout()"><i
              class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i> Logout</a>
        </div>
      </div>

      <!-- <div class="dropdown d-inline-block">
        <button type="button" class="btn header-item noti-icon right-bar-toggle" (click)="toggleRightSidebar()">
          <i class="bx bx-cog bx-spin"></i>
        </button>
      </div> -->

    </div>
  </div>
</header>



<!-- Center Modal -->
<ng-template #infoDataModal let-modal>
  <div class="modal-header" *ngIf="selectedCompany != null">
    <h5 class="modal-title mt-0">Company name: {{selectedCompany.company_name}} </h5>
    <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
  </div>
  <div class="modal-body" *ngIf="selectedCompany != null">
    <div class="table-responsive">
      <table class="table table-centered table-nowrap">
        <thead>
          <tr>
            <th scope="col"> <span class="text-primary"> Parameter</span></th>
            <th scope="col"> <span class="text-primary"> Value</span></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">Type</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.role_type}} </h5>
                <!-- <p class="text-muted mb-0">$ 225 x 1</p> -->
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">Created</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.added | date: 'dd/MM/yyyy HH:mm'}}</h5>
                <!-- <p class="text-muted mb-0">$ 225 x 1</p> -->
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">API token</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.api_token}}</h5>
              </div>
            </td>
          </tr>
          <!-- <tr *ngIf="selectedCompany.role_type == 'Customer'">
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">Customer Id</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.customer_id}}</h5>
              </div>
            </td>
          </tr> -->
          <tr>
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">Company Token</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.company_token}}</h5>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">Security Token</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.security_token}}</h5>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">User UID</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.ref_uid}}</h5>
              </div>
            </td>
          </tr>
          <tr>
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">User Mail</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.ref_mail}}</h5>
              </div>
            </td>
          </tr>
          <!-- <tr *ngIf="selectedCompany.role_type != 'SuperUser'">
            <th scope="row">
              <div>
                <h5 class="text-truncate font-size-12">Verified</h5>
              </div>
            </th>
            <td>
              <div>
                <h5 class="text-truncate font-size-12">{{selectedCompany.verified}}</h5>
              </div>
            </td>
          </tr>  -->
        </tbody>
      </table>
    </div>
  </div>
</ng-template>